<template>
  <div class="ignore-mobile-page news-page">
    <div class="ignore-content-wrapper">
      <news-item
        v-for="item in newsList"
        class="item"
        :key="item.id"
        :title="item.title"
        :cover="item.cover"
        :url="item.url"
        tag="大事记"
        :date="item.ctime"></news-item>
    </div>
    <car-footer></car-footer>
  </div>
</template>

<script>
import carFooter from '../../../components/mobile/footer';
import newsItem from '../../../components/news-item';
import axios from 'axios';

export default {
  components: { carFooter, newsItem },
  data () {
    return {
      newsList: []
    };
  },
  async created () {
    let res = await axios.get('/web/news/');
    if (res.status === 200) {
      this.newsList = res.data.results;
    }
  }
};
</script>

<style lang="scss" scopedd>
.news-page {
  background: #fff;
  .ignore-content-wrapper {
    width: 100%;
    box-sizing: border-box;
    padding: 15px;

    .item {
      margin-bottom: 15px;

      .title {
        font-size: 14px !important;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
